export const AUTH_HEADERS = {
    X_PETM_REQUEST_ID: 'x-petm-request-id',
    X_PETM_ANONYMOUS_KEY: 'x-petm-anonymous-key',
    X_PETM_CHATBOT_ENABLED: 'x-petm-chatbot-enabled',
    X_PETM_CHATBOT_MODEL: 'x-petm-chatbot-model',
    X_PETM_CHATBOT_REASONING: 'x-petm-chatbot-reasoning',
    X_PETM_CUSTOMER_KEY: 'x-petm-customer-key',
    X_PETM_GUEST_SESSION_ID: 'x-petm-guest-session-id',
    X_PETM_CUSTOMER_UUID: 'x-petm-customer-uuid',
    X_PETM_DECISIONS: 'x-petm-decisions',
    X_PETM_CART_ID: 'x-petm-cart-id',
    X_PETM_SKIP_RECAPTCHA: 'x-petm-account-skip-recaptcha',
    X_PETM_LOYALTY_NUMBER: 'x-petm-customer-loyalty-number',
    X_VERCEL_PROECTION_BYPASS: 'x-vercel-protection-bypass',
    X_PETM_CHANNEL: 'x-petm-channel',
    X_PETM_VISITOR_ID: 'x-petm-visitor-id',
    X_PETM_CLIENT_IP: 'x-petm-client-ip',
    X_PETM_FORWARDED_FOR: 'petm-x-forwarded-for',
    X_PETM_STORE_ID: 'x-petm-store-id',
    X_PETM_LOCALE: 'x-petm-locale',
    X_PETM_TIMEZONE: 'x-petm-timezone',
    X_PETM_EPH_ENV: 'x-petm-eph-env',
    X_PETM_AUTH0_ENABLED: 'x-petm-auth0-enabled',
    X_PETM_AUTH_SUBJECT: 'x-petm-auth-subject',
    X_PETM_AUTH_ASSURANCE: 'x-petm-auth-assurance',
    X_PETM_SOURCE_LOCATION: 'x-petm-source-location',
    AUTHORIZATION: 'Authorization',
    CONTENT_TYPE: 'Content-Type',
} as const;

/**
 * Query parameters to exclude from the cache key.
 * These parameters typically do not affect the page results and are often used by tracking or third-party services.
 */
export const EXCLUDED_PARAMS = [
    'utm_source',
    'utm_content',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_id',
    'mi_u',
    'mi_ecmp',
    'sfmc_id',
    'rid',
    'gclsrc',
    'gad_source',
    'gbraid',
    'gclsrc',
] as [string, ...string[]];
